import React from "react";
import { IPolicy } from "../../generated/models/policy";
import { MissionType } from "../../generated";

import "./style.css";

export const TokenPolicy = (props: IPolicy) => {
  const isVRP = props.missionType === MissionType.VRPCONSENT;

  return (
    <div className="mt-3 mb-3">
      <div className="policy-powered-by-info">
        Powered by Token: You use Token&apos;s Payment service to{" "}
        {isVRP ? <>enable</> : <>make a</>} secure payment directly from your
        bank account.
      </div>
      <div>
        By clicking the button {props.buttonPosition}, You are agreeing to
        <a href="https://token.io/terms" target="_blank" rel="noreferrer">
          {" "}
          Token&apos;s Terms & Privacy Policy
        </a>
        .&nbsp;
        {!isVRP && (
          <>
            You consent to the processing of your financial data, for the
            purpose of quality control the connection of {props.providerId}
            .&nbsp;
          </>
        )}
        We will create a {isVRP ? <>consent</> : <>payment</>} on your behalf,
        and for that purpose we might process the list of accounts you have
        access to.
      </div>
    </div>
  );
};
